import React, { memo, useState } from "react";
import { Box, Grid, Grid2, Typography, useMediaQuery } from "@mui/material";
import { GENDER, USER_ROLES } from "../../../utils/constants";
import { findObjectKeyByValue } from "../../../utils/constants";
import moment from "moment";
import SubmitButton from "../../../components/button/SubmitButton";
import ChartComponent from "../../../components/ChartComponent";
import { useSelector } from "react-redux";

const PatientInformation = ({ params}) => {
  const { user } = useSelector((state) => state);
  const [rightBcData, setRightBcData] = useState([
    params?.rf?.rf250,
    params?.rf?.rf500,
    params?.rf?.rf1k,
    params?.rf?.rf2k,
    params?.rf?.rf4k,
    params?.rf?.rf6k,
  ]);

  const [leftBcData, setLeftBcData] = useState([
    params?.lf?.lf250,
    params?.lf?.lf500,
    params?.lf?.lf1k,
    params?.lf?.lf2k,
    params?.lf?.lf4k,
    params?.lf?.lf6k,
  ]);
  return (
    <Box>
      <Box>
        <Grid2 container spacing={2} size={14}>
          <Grid2
            size={6}
            sx={{ border: "1px solid #101536", borderRadius: "8px" }}
          >
            <Box
              p={2}
              sx={{
                height: "7vh",
                borderBottom: "1px solid #101536",
                backgroundColor: "#F6FAFF",
                borderRadius: "8px 8px 0 0",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography fontWeight={800} variant="h4">
                Patient Details
              </Typography>
            </Box>

            <Box sx={{ ml:1}}>
            <Grid2 container p={2} size={12}>
              <Grid2 item mt={2} size={2.5}>
                <Typography
                  fontWeight="bold"
                  variant="body1"
                  sx={{ color: "#808080" }}
                >
                  Patient Name :{" "}
                </Typography>
              </Grid2>

              <Grid2 item mt={2} size={3.5}>
                <Typography
                  variant="body1"
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                 {params?.name || "NA"}
                </Typography>
              </Grid2>

              {user?.data?.role !== USER_ROLES?.ASSEMBLY && (
                <>
              <Grid2 item mt={2} size={2.5}>
                <Typography
                  fontWeight="bold"
                  variant="body1"
                  sx={{ color: "#808080" }}
                >
                  Gender :{" "}
                </Typography>
              </Grid2>

              <Grid2 item mt={2} size={3.5}>
                <Typography
                  variant="body1"
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  {findObjectKeyByValue(params?.gender, GENDER)}
                </Typography>
              </Grid2>
                </> 
                )}

                {user?.data?.role == USER_ROLES?.ASSEMBLY && (
                <>
                  <Grid2 item mt={2} size={2.5}>
                    <Typography
                      fontWeight="bold"
                      variant="body1"
                      sx={{ color: "#808080" }}
                    >
                      Assigned Date :{" "}
                    </Typography>
                  </Grid2>

                  <Grid2 item mt={2} size={3.5}>
                    <Typography
                      variant="body1"
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      {params?.order_ID?.assigned_date
                            ? moment(params?.order_ID?.assigned_date).format("DD/MM/YYYY")
                            : "NA"}
                    </Typography>
                  </Grid2>
                </> 
                )}
            </Grid2>
            
            {user?.data?.role !== USER_ROLES?.ASSEMBLY && (
              <>
            <Grid2 container p={2} size={12}>
              <Grid2 item size={2.5}>
                <Typography
                  fontWeight="bold"
                  variant="body1"
                  sx={{ color: "#808080" }}
                >
                  Age :
                </Typography>
              </Grid2>

              <Grid2 item size={3.5}>
                <Typography
                  variant="body1"
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  {params?.age || "NA"}
                </Typography>
              </Grid2>

              <Grid2 item size={2.5}>
                <Typography
                  fontWeight="bold"
                  variant="body1"
                  sx={{ color: "#808080" }}
                >
                  Phone No. : {" "}
                </Typography>
              </Grid2>

              <Grid2 item size={3.5}>
                <Typography
                  variant="body1"
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  {params?.patient_phone || "NA"}
                </Typography>
              </Grid2>
            </Grid2>
            </>
            )}

            <Grid2 container p={2} size={12}>
            {user?.data?.role !== USER_ROLES?.ASSEMBLY && (
              <>
                <Grid2 item size={2.5}>
                  <Typography
                    fontWeight="bold"
                    variant="body1"
                    sx={{ color: "#808080" }}
                  >
                    Guardian No. :{" "}
                  </Typography>
                </Grid2>

                <Grid2 item size={3.5}>
                  <Typography
                    variant="body1"
                    sx={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    {params.patient_guardian_no || "NA"}
                  </Typography>
                </Grid2>
              </>
              )}

              <Grid2 item size={2.5}>
                <Typography
                  fontWeight="bold"
                  variant="body1"
                  sx={{ color: "#808080" }}
                >
                  Temporal Arc :{" "}
                </Typography>
              </Grid2>

              <Grid2 item size={3.5}>
                <Typography variant="body1" sx={{ wordBreak: "break-word" }}>
                {params.upperHeadCircumference
                    ? params?.upperHeadCircumference + " cm"
                    : "NA"}
                </Typography>
              </Grid2>

              {user?.data?.role == USER_ROLES?.ASSEMBLY && (
                <>
                  <Grid2 item size={2.5}>
                    <Typography
                      fontWeight="bold"
                      variant="body1"
                      sx={{ color: "#808080" }}
                    >
                      Delivery Date :{" "}
                    </Typography>
                  </Grid2>

                  <Grid2 item size={3.5}>
                    <Typography
                      variant="body1"
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      {params?.order_ID?.assigned_date
                        ? moment(params?.order_ID?.assigned_date)
                            .add(10, "days")
                            .format("DD/MM/YYYY")
                        : "NA"}
                    </Typography>
                  </Grid2>
                </> 
                )}
            </Grid2>

            <Grid2 container p={2} size={12}>
            {user?.data?.role !== USER_ROLES?.ASSEMBLY && (
              <>  
                <Grid2 item size={2.5}>
                  <Typography
                    fontWeight="bold"
                    variant="body1"
                    sx={{ color: "#808080" }}
                  >
                    State :{" "}
                  </Typography>
                </Grid2>

                <Grid2 item size={3.5}>
                  <Typography
                    variant="body1"
                    sx={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    {params?.state || "NA"}
                  </Typography>
                </Grid2>
              </>
            )}

              <Grid2 item size={2.5}>
                <Typography
                  fontWeight="bold"
                  variant="body1"
                  sx={{ color: "#808080" }}
                >
                  Temporal Width :{" "}
                </Typography>
              </Grid2>

              <Grid2 item size={3.5}>
                <Typography
                  variant="body1"
                  sx={{ display: "flex", justifyContent: "flex-start", wordBreak: "break-word" }}
                > 
                  {params.temporalBoneWidth
                    ? params?.temporalBoneWidth + " cm"
                    : "NA"}
                </Typography>
              </Grid2>

              {user?.data?.role == USER_ROLES?.ASSEMBLY && (
                <>
                  <Grid2 item size={2.5}>
                    <Typography
                      fontWeight="bold"
                      variant="body1"
                      sx={{ color: "#808080" }}
                    >
                      Time Duration :{" "}
                    </Typography>
                  </Grid2>

                  <Grid2 item size={3.5}>
                    <Typography
                      variant="body1"
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      {/* {params?.order_ID?.assigned_date
                        ? `${moment(params?.order_ID?.assigned_date)
                            .add(10, "days")
                            .diff(moment(), "days")} days`
                        : "NA"} */}
                        {params?.order_ID?.assigned_date 
                          ? (() => {
                              const assignedDate = moment(params.order_ID.assigned_date).startOf("day");
                              const deliveryDate = assignedDate.clone().add(10, "days"); // includes assigned date
                              const today = moment().startOf("day");
                              const remainingDays = deliveryDate.diff(today, "days");
                              return `${remainingDays} days`;
                            })()
                          : "NA"}
                    </Typography>
                  </Grid2>
                </> 
                )}
            </Grid2>

            <Grid2 container p={2} size={12}>
            {user?.data?.role !== USER_ROLES?.ASSEMBLY && (
              <>
                <Grid2 item size={2.5}>
                  <Typography
                    fontWeight="bold"
                    variant="body1"
                    sx={{ color: "#808080" }}
                  >
                    City :{" "}
                  </Typography>
                </Grid2>

                <Grid2 item size={3.5}>
                  <Typography
                    variant="body1"
                    sx={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    {params?.city || "NA"}
                  </Typography>
                </Grid2>
              </>
            )}

              <Grid2 item size={2.5}>
                <Typography
                  fontWeight="bold"
                  variant="body1"
                  sx={{ color: "#808080" }}
                >
                  Head Circumference :{" "}
                </Typography>
              </Grid2>

              <Grid2 item size={3.5}>
                <Typography
                  variant="body1"
                  sx={{ mt:3, display: "flex", justifyContent: "flex-start", wordBreak: "break-word" }}
                >
                  {params.foreheadToBackheadCircumference
                    ? params?.foreheadToBackheadCircumference + " cm"
                    : "NA"}
                </Typography>
              </Grid2>
            </Grid2>

            <Grid2 container p={2} size={12}>
              <Grid2 item size={2.5}>
                <Typography
                  fontWeight="bold"
                  variant="body1"
                  sx={{ color: "#808080" }}
                >
                  Patient Type :{" "} 
                </Typography>
              </Grid2>

              <Grid2 item size={9.5}>
                <Typography
                  variant="body1"
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  {params.patient_of + "  " || "NA"}
                </Typography>
              </Grid2>
            </Grid2>

            <Grid2 container p={2} size={12}>
            {user?.data?.role !== USER_ROLES?.ASSEMBLY && (
              <>
              <Grid2 item size={2.5}>
                <Typography
                  fontWeight="bold"
                  variant="body1"
                  sx={{ color: "#808080" }}
                >
                  Address :
                </Typography>
              </Grid2>

              <Grid2 item size={9.5}>
                <Typography
                  variant="body1"
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  {params.patient_address || "NA"}
                </Typography>
              </Grid2>
            </>
            )}
            </Grid2>
            </Box>
          </Grid2>

          <Grid2
            size={6}
            sx={{ border: "1px solid #101536", borderRadius: "8px" }}
          >
            <Box
              p={2}
              sx={{
                height: "7vh",
                backgroundColor: "#F6FAFF",
                borderBottom: "1px solid #101536",
                borderRadius: "8px 8px 0 0",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight={800} variant="h4">
                  Audiogram Details
                </Typography>
              </Box>
            </Box>

            <Grid2
              p={4}
              gap={2}
              container
              size={12}
              display={"flex"}
              direction={params.affected_ear === 3 ? "row" : "column"}
              alignItems="center"
              justifyContent={
                params.affected_ear === 3 ? "space-evenly" : "center"
              }
            >
              {(params.affected_ear === 2 || params.affected_ear === 3) && (
                <Grid2 size={5}>
                  <Box
                    sx={{
                      backgroundColor: "#FFF6F6",
                      display: "flex",
                      flexDirection: "column",
                      minHeight: "35vh",
                      maxHeight: "35vh",
                      minWidth: "10vw",
                      maxWidth: "15vw",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      <Typography color="error" variant="body1" ml={4}>
                        • Right
                      </Typography>
                    </Box>

                    <ChartComponent
                      allowed_bc={params?.allowed_bc}
                      data={rightBcData}
                      title="BC"
                      rightEar
                      readonly={true}
                    />
                  </Box>
                </Grid2>
              )}

              {(params.affected_ear === 1 || params.affected_ear === 3) && (
                <Grid2 size={5}>
                  <Box
                    sx={{
                      backgroundColor: "#F6FAFF",
                      display: "flex",
                      flexDirection: "column",
                      minHeight: "35vh",
                      maxHeight: "35vh",
                      minWidth: "10vw",
                      maxWidth: "15vw",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "flex-start",
                      }}
                    >
                      <Typography color="primary" variant="body1" ml={4}>
                        • Left
                      </Typography>
                    </Box>
                    <ChartComponent
                      allowed_bc={params?.allowed_bc}
                      data={leftBcData}
                      title="BC"
                      leftEar
                      readonly={true}
                    />
                  </Box>
                </Grid2>
              )}

              <Grid2 container alignItems="center" sx={{ mt: 4 }} spacing={3}>
                <Grid2 item xs={2.5}>
                  <Typography
                    fontWeight="bold"
                    variant="body1"
                    sx={{ color: "#808080" }}
                  >
                    Affected Ear :
                  </Typography>
                </Grid2>

                <Grid2 item xs={1.5}>
                  <Typography variant="body1">
                    {params?.affected_ear === 1
                      ? "LEFT"
                      : params?.affected_ear === 2
                      ? "RIGHT"
                      : params?.affected_ear === 3
                      ? "BOTH"
                      : "NA"}
                  </Typography>
                </Grid2>
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
      </Box>

      <Grid2 mt={2} container spacing={2} size={12}>
        <Grid2
          sx={{ border: "1px solid #101536", borderRadius: "8px" }}
          size={12}
          // minHeight={"30vh"}
        >
          <Grid2>
            <Box
              p={2}
              sx={{
                height: "7vh",
                borderBottom: "1px solid #101536",
                backgroundColor: "#F6FAFF",
                borderRadius: "8px 8px 0 0",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography fontWeight={800} variant="h4">
                References
              </Typography>
            </Box>
          </Grid2>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 2,
            }}
          >
            {params?.ref_image_front_Head && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mt: 2,
                  width: "100%",
                  flexDirection: "column",
                }}
              >
                <Box>
                  <Typography fontWeight={800} variant="h6" sx={{}}>
                    Front Head Reference Image
                  </Typography>
                </Box>
                <Box>
                  <img
                    src={params?.ref_image_front_Head}
                    alt="Preview"
                    style={{
                      width: "100%",
                      justifyContent: "center",
                      display: "flex",
                      maxWidth: "300px",
                      minWidth: "300px",
                      height: "100%",
                      maxHeight: "45vh",
                      minHeight: "45vh",
                      objectFit: "cover",
                      borderRadius: 5,
                      border: "3px solid #101536",
                    }}
                  />
                </Box>
              </Box>
            )}

            {params?.ref_image_left_Head && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 2,
                  width: "100%",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography fontWeight={800} variant="h6" sx={{}}>
                    Reference Image - Left Side Head
                  </Typography>
                </Box>
                <Box>
                  <img
                    src={params?.ref_image_left_Head}
                    alt="Preview"
                    style={{
                      width: "100%",
                      maxWidth: "300px",
                      minWidth: "300px",
                      height: "100%",
                      maxHeight: "45vh",
                      minHeight: "45vh",
                      objectFit: "cover",
                      borderRadius: 5,
                      border: "3px solid #101536",
                    }}
                  />
                </Box>
              </Box>
            )}

            {params.ref_image_right_Head && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 2,
                  width: "100%",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography fontWeight={800} variant="h6" sx={{}}>
                    Reference Image - Right Side Head
                  </Typography>
                </Box>
                <Box>
                  <img
                    src={params?.ref_image_right_Head}
                    alt="Preview"
                    style={{
                      width: "100%",
                      minHeight: "45vh",
                      minWidth: "300px",
                      maxWidth: "300px",
                      height: "100%",
                      maxHeight: "45vh",
                      objectFit: "cover",
                      borderRadius: 5,
                      border: "3px solid #101536",
                    }}
                  />
                </Box>
              </Box>
            )}
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default memo(PatientInformation);
